define('home/views/PromotedChannelsCardView',[
    'backbone-marionette',

    'home/views/ChannelPromotionView',
], function (
    Marionette,

    ChannelPromotionView
) {
    'use strict';

    var PromotedChannelsCardView = Marionette.CollectionView.extend({
        className: 'card--interstitial',
        itemView: ChannelPromotionView,
    });

    return PromotedChannelsCardView;
});

